import React, { PropTypes } from "react";

import Choice from "../../../Atoms/Choice";

export default function MultiCheckbox({ label, choices, value, onChange, labels }) {
    const formattedChoices = {};

    Object.keys(choices).forEach(key => (formattedChoices[key] = `${choices[key].label} (${choices[key].count})`) );

    return (
      <Choice
          name={label}
        choices={formattedChoices}
        multiple
        expanded
        forceRender
        value={value}
        onChange={onChange}
        labels={labels}
      />
    );
}

MultiCheckbox.propTypes = {
    choices: PropTypes.objectOf(React.PropTypes.shape({
        label: PropTypes.string.isRequired,
        count: PropTypes.number.isRequired,
    })).isRequired,
    value: PropTypes.string,
    onChange: PropTypes.func,
    class: PropTypes.string,
    labels: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/Resources/public/rosco/js/ProductBrowser/Atoms/Facet/MultiCheckbox.jsx